import React from 'react';

import { Container } from './styles';

export default function Strong({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}
